import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MemberEndorsementForm from '../../../components/forms/MemberEndorsementForm';
import { useMemberEndorsementApi } from '../../../hooks/useMemberEndorsementApi';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { MemberEndorsementDTO } from '../../../services/apiClient';

const MemberEndorsementCreate: React.FC = () => {
  const { create, isLoading } = useMemberEndorsementApi();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const licenceTypeId = searchParams.get('licenceTypeId') ?? undefined;
  const memberFirearmId = searchParams.get('memberFirearmId') ?? undefined;

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Endorsements', href: '/admin/memberendorsements' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: MemberEndorsementDTO) => {
    try {
      setIsSubmitting(true);
      await create(data);
      navigate(-1);
    } catch (error) {
      console.error('Error creating MemberEndorsement:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/memberendorsements"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin', 'User']}
      requiredPermission='Manage.MemberEndorsement.Edit'
    >
      <MemberEndorsementForm
        initialValues={{ licenceTypeId, memberFirearmId } as MemberEndorsementDTO}
        onSubmit={handleSubmit}
        onCancel={() => navigate(-1)}
        isLoading={isSubmitting}
      />
    </AdminLayout>
  );
};

export default MemberEndorsementCreate;